// extracted by mini-css-extract-plugin
export default {"group":"style_group__k8bRA","msg":"style_msg__cC5kl"};